<template>
    <div>
      <div class="modal fade" id="historial_ingresos" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
          <div class="modal-dialog modal-fullscreen">
              <div class="modal-content" :style="skin.header_desktop.nav_bar">
                  <div class="modal-body p-4" style="font-family: 'Exo 2', sans-serif !important;">
                      <div class="container form-large">
                          <form @submit.prevent="" class="">
                            <h1 :style="{'color':skin.main_modal_background}">{{ translate('my_account') }}</h1>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('screen') }}</label><br>
                                <select name="" class="input-custom">
                                    <option value="Home">{{ translate('inicio') }}</option>
                                </select>
                            </div>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('language') }}</label><br>
                                <select name="" class="input-custom">
                                    <option value="Home">{{ translate('language1') }}</option>
                                </select>
                            </div>
                                <label style="color:white" for="">{{ translate('user') }}</label><br><br>
                                <label style="color:white" for="">{{ user.user_data?.data?.user_name }}</label><br><br>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('name') }}</label><br>
                                <input type="text" class="input-custom">
                            </div>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('surname') }}</label><br>
                                <input type="text" class="input-custom">
                            </div>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('email') }}</label><br>
                                <input type="text" class="input-custom">
                            </div>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('telephone') }}</label><br>
                                <input type="text" class="input-custom">
                            </div>
                            <div class="pb-2 font-size-custom mb-3 my-3">
                                <label style="color:white" for="">{{ translate('address') }}</label><br>
                                <input type="text" class="input-custom">
                            </div>
                                <div class="d-grid gap-2">
                                    <button class="btn p-2 mx-2" type="button" :style="{'background-color':skin.main_modal_background, 'color':skin.main_modal_text}" style="font-size: small;font-weight: bold;" data-bs-dismiss="modal" aria-label="Close">{{ translate('keep') }}</button>
                                    <button class="btn p-2 mx-2" type="button" :style="{'background-color':skin.main_modal_background, 'color':skin.main_modal_text}" style="font-size: small;font-weight: bold; text-transform: uppercase;" data-bs-dismiss="modal" aria-label="Close">{{ translate('close') }}</button>
                                </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
      name:"misDatos",
      props:['skin','translation','language'],
      data(){
          return {
              password:"",
              password2:"",
              show1:true,
              show2:true,
              status:{
                  message:"",
                  type:""
              },
              login_inProcess:false
          }
      },
      computed:{
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        showChangePassword(){
            return this.$store.getters['getShowChangePassword'];
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
      },
      methods:{
          async changePassword(){
                try {
                    this.login_inProcess = true;
                    let data = await axios.post(this.apiUrlnew+"cambiar_password", 
                    {
                        "users": [this.user.user_data.data.user_id ?? this.user.user_data.data.id],
                        "password": this.password,
                        "password1": this.password2,
                        "token":this.user.token,
                        "login_id":this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                        "site": this.site
                    })
                    if(data.data.error){
                        this.status.message = data.data.error;
                        this.status.type = "danger";
                    }
                    else{
                        this.status.message = data.data.message;
                        this.status.type = "success";
                        this.logout();
                        setTimeout(()=>{
                            document.getElementById("closeChangePassword").click();
                        },2000)
                    }
                    this.login_inProcess = false;
                } catch (error) {
                    this.status.message = error.response.data.error;
                    this.status.type = "danger";
                    this.login_inProcess = false;
                }
                
          },
        logout(){
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
          translate(text) {
              if(text){
                  if (this.$props.translation[text]) {
                      return this.$props.translation[text][this.$props.language];
                  }
                  else{
                      var new_text_serched = text.replace(/ /g, "_");
                      if (this.$props.translation[new_text_serched]) {
                          return this.$props.translation[new_text_serched][this.$props.language];
                      }
                  }
                  return text;
              }
          },
          show_hide_Password(target){
            if(target == "password"){
                document.getElementById(target).type = this.show1?"text":"password";
                this.show1 = !this.show1;
            }
            else{
                document.getElementById(target).type = this.show2?"text":"password";
                this.show2 = !this.show2;
            }
          },
      }
  }
  </script>
  
  <style scoped>
  .modal-header2 {
      margin-left: 5%!important;
      margin-right: 5%!important;
      margin-top: -1.25rem!important;
      margin-bottom: 0!important;
      height: 60px;
      padding: 1rem!important;
      color: #fff;
      border-bottom: none;
      background:linear-gradient(40deg,#292d3d,#03040d)!important
  }
  .close2 {
      float: right;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: .5;
  }
  .login-user-control{
      color: #fff;
      margin-left: 2.5rem;
      width: calc(100% - 2.5rem);
      -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
      -o-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
      outline: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: none;
      border-bottom: 1px solid #ced4da;
      -webkit-border-radius: 0;
      border-radius: 0;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      background-color: transparent;
      margin: 0 0 0.5rem;
      -webkit-border-radius: 0;
      border-radius: 0;
      padding: 0.3rem 0 0.55rem;
      background-image: none;
      background-color: transparent;
      height: auto;
  }
  h1 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 18px;
}
.form-large {
    padding: 50px;
    border-radius: 20px;
    margin-top: 35px;
    background-color: black;
    padding: 30px;
    border-radius: 20px;
    max-width: 480px;
}
.input-custom{
    font-size: 1rem;
    background-color: #2e2e2e;
    color: #fff;
    border-radius: 6px;
    padding: 10px 20px;
    line-height: .75em;
    width: 100%;
    border: 1px solid rgba(22, 22, 22, .082);
}
  </style>